<template>
	<div id="searchVehicle">
		<section class="content-header">
			<div class="container-fluid">
				<div class="row mb-2">
					<div class="col-md-6 col-12">
						<h1>{{ $t("label.search_vehicle")}}</h1>
					</div>
					<div class="col-md-6">
						<ol class="breadcrumb float-sm-right">
							<li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
							<li class="breadcrumb-item active">{{ $t("label.vehicle")}}</li>
						</ol>
					</div>
				</div>
			</div>
		</section>

		<div class="content">
			<div class="container-fluid">
				<div class="card card-success card-outline">
					<div class="card-header px-2">
						<h3 class="card-title">{{ $t("label.search_vehicle")}}</h3>
						<div class="card-tools">
							<button type="button" class="btn btn-tool" data-widget="collapse" :title="$t('label.collapse')" @click="collapse.display = !collapse.display">
								<fa :icon="collapse.display ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
							</button>
						</div>
					</div>
					<div class="card-body">
						<table class="table table-sm table-bordered tblfind" cellspacing="0" cellpadding="0">
							<tr>
								<th width="20%">{{ $t("label.name")}}</th>
								<th width="20%">{{ $t("label.criteria")}}</th>
								<th width="30%">{{ $t("label.value_1")}}</th>
								<th width="30%">{{ $t("label.value_2")}}</th>							
							</tr>
							<tr>
								<th>{{ $t("label.plate_number")}}</th>
								<td>
									<div class="form-group">
										<select v-model="plate_number.criteria" class="form-control" id="plate_number" name="plate_number">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
											<option value="contain">{{ $t("label.contain")}}</option>
										</select> 
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="plate_number.v1" :data-vv-as="$t('label.plate_number')" name="plate_number_v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('plate_number_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="plate_number.v2" :data-vv-as="$t('label.plate_number')" name="plate_number_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('plate_number_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t('label.nationality')}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" id="nationality" v-model="nationality.criteria" :data-vv-as="$t('label.nationality')" name="nationality">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">										
										<v-select v-if="nationality.criteria == 'all'"
											v-model="nationality.v1"
											name="nationality_v1"
											class="nationality_v1 disabled"       
											:data-vv-as="$t('label.nationality')"
											:options="countries"
											disabled
											label="name">
										</v-select>
										<v-select v-else
											v-model="nationality.v1"
											name="nationality_v1" 
											class="nationality_v1"                                  
											v-validate="'required'" 
											:data-vv-as="$t('label.nationality')"
											:options="countries"
											label="name">
										</v-select>
										<span class="error_smg">{{ errors.first('nationality_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="nationality.v2" :data-vv-as="$t('label.nationality')" name="nationality_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('nationality_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.brand")}}</th>
								<td>
									<div class="form-group">
										<select class="form-control" id="brand" v-model="brand.criteria" :data-vv-as="$t('label.brand')" name="brand">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
											<option value="contain">{{ $t("label.contain")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="brand.v1" :data-vv-as="$t('label.brand')" name="brand_v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('brand_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="brand.v2" :data-vv-as="$t('label.brand')" name="brand_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('brand_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.engine_number")}}</th>
								<td>
									<div class="form-group">
										<select v-model="engine_number.criteria" class="form-control" id="engine_number" name="engine_number">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select> 
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="engine_number.v1" :data-vv-as="$t('label.engine_number')" name="engine_number_v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('engine_number_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="engine_number.v2" :data-vv-as="$t('label.engine_number')" name="engine_number_v2" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('engine_number_v2') }}</span>
									</div>
								</td>
							</tr>
							<tr>
								<th>{{ $t("label.frame_number")}}</th>
								<td>
									<div class="form-group">
										<select v-model="frame_number.criteria" class="form-control" id="frame_number" name="frame_number">
											<option value="all">{{ $t("label.all")}}</option>
											<option value="equal">{{ $t("label.equal")}}</option>
											<option value="not_equal">{{ $t("label.not_equal")}}</option>
										</select>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control" v-model="frame_number.v1" :data-vv-as="$t('label.identity_card')" name="frame_number_v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('frame_number_v1') }}</span>
									</div>
								</td>
								<td>
									<div class="form-group">
										<input type="text" class="form-control"  v-model="frame_number.v2" :data-vv-as="$t('label.identity_card')" name="frame_number.v1" v-validate="'required'" disabled>
										<span class="error_smg">{{ errors.first('c') }}</span>
									</div>
								</td>
							</tr>
						</table>
					</div>
					<div class="card-footer">
						<button data-id="search" type="button" class="btn btn-sm btn-primary float-right" @click.prevent="searchVehicle(1, 'created_at', 'asc')"><fa :icon="fas.faSearch" class="left fa fa-circle-o nav-icon" />{{ $t('label.search') }}</button>
					</div>
				</div>

				<div class="card card-success card-outline">
					<div class="card-header px-2">
						<h3 class="card-title">{{ $t("label.vehicle")}}</h3>
						<div class="card-tools">
							<button type="button" class="btn btn-tool" data-widget="collapse" :title="$t('label.collapse')" @click="collapse.display = !collapse.display">
								<fa :icon="collapse.display ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
							</button>
						</div>
					</div>
					<div class="card-body">
						<div class="table-responsive" v-if="vehicles.length > 0">
							<table class="table table-bordered mb-0">
								<thead>
									<tr class="cursor-pointer">
										<th nowrap></th>
										<th nowrap @click="searchVehicle(1, 'brand', order_type, true)">{{$t('label.brand')}}</th>
										<th nowrap @click="searchVehicle(1, 'plate_number', order_type, true)">{{$t('label.plate_number')}}</th>
										<th nowrap @click="searchVehicle(1, 'frame_number', order_type, true)">{{$t('label.frame_number')}}</th>
										<th nowrap @click="searchVehicle(1, 'engine_number', order_type, true)">{{$t('label.engine_number')}}</th>
										<th nowrap @click="searchVehicle(1, 'color', order_type, true)">{{$t('label.color')}}</th>
										<th nowrap @click="searchVehicle(1, 'year', order_type, true)">{{$t('label.year')}}</th>
										<th nowrap @click="searchVehicle(1, 'created_at', order_type, true)">{{$t('label.created_at')}}</th>
										<th nowrap style="witdh: 1%;"></th>
									</tr>
								</thead>
								<tbody  >
									<tr v-for="(vehicle, index) in vehicles" :key="index" :value="vehicle.code">
										<td nowrap>{{(pageNumber*10-10)+index+1}}</td>
										<td nowrap>{{vehicle.brand}}</td>
										<td nowrap>{{vehicle.plate_number}}</td>
										<td nowrap>{{vehicle.frame_number}}</td>
										<td nowrap>{{vehicle.engine_number}}</td>
										<td nowrap>{{vehicle.color}}</td>
										<td nowrap>{{vehicle.year}}</td>
										<td nowrap>{{vehicle.created_at}}</td>
										<td nowrap style="text-align:center">
											<router-link v-if="$hasPermission('tempvehicle.vehicle.view')" :to="{name : 'VehicleDetail', params: { id: vehicle.uuid }}" class="mr-2" :title="$t('label.view')" target="_blank">
                        <fa :icon="fas.faEye" style="color: #007bff;"/>
                      </router-link>
                      <router-link v-if="$hasPermission('tempvehicle.vehicle.edit')" :to="{name : 'EditVehicle', params: { id: vehicle.uuid }}" class="mr-2" :title="$t('label.edit')" target="_blank">
                        <fa :icon="fas.faEdit" style="color: green;"/>
                      </router-link>
											<a v-if="$hasPermission('tempvehicle.vehicle.delete')" href="javascript: void(0)" @click="deleteVehicle(vehicle.uuid)" :title="$t('label.delete')">
												<fa :icon="fas.faTrash" style="color: red;"/>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="callout callout-success" v-else>
							<label>{{$t('label.no_data')}}</label>
						</div>
					</div>
					<div class="card-footer" v-if="vehicles.length > 0">
						<paginate class="mb-0"
							:page-count="last_page"
							:force-page="forcepage"
							:page-range="3"
							:margin-pages="2"
							:click-handler="searchVehicle"
							:container-class="'pagination float-right'"
							:prev-text="'Prev'"
							:next-text="'Next'"
							:page-class="'page-item'"
							:active-class="'active'"
							:prev-link-class="'page-link'"
							:next-link-class="'page-link'"
							:page-link-class="'page-link'"
							ref="paginate">
						</paginate>
					</div>
				</div>
			</div>
		</div>
	</div>  
</template>

<script>
	import { fas } from "@fortawesome/free-solid-svg-icons";
	export default {
		name: 'SearchVehicle',
		data(){
			return {
				permission:{
					deleteVehicle: false,
				},
				baseURI : '',
				forcepage: 1,
				pageNumber:1,
				last_page: 0,
				countries: [],
				is_disabled: false,
				plate_number:{
					criteria: "all",
					v1:'',
					v2:''
				},
				nationality:{
					criteria: "all",
					v1:'',
					v2:''
				},
				brand:{
					criteria: "all",
					v1:'',
					v2:''
				},
				engine_number:{
					criteria: "all",
					v1:'',
					v2:''
				},
				frame_number:{
					criteria: "all",
					v1:'',
					v2:''
				},
				vehicles:[],
				order_by:'created_at',
				order_type:'asc',
				order_type_after_sort:'',
				histories: [],
				collapse:{
					search: false,
					display: false,
				}
			}
		},
		watch: {
			"plate_number.criteria" : function(val){
				if(val == "all"){
					this.plate_number.v1 = '';
					this.errors.remove('plate_number_v1');
					return this.plate_number;
				}
			},
			"nationality.criteria": function(val){
				if(val == "all"){
					this.nationality.v1 = '';
					this.nationality.v2 = '';
					this.errors.remove('nationality_v1');
					return this.nationality;
				}	
			},
			"brand.criteria": function(val){
				if(val == "all"){
					this.brand.v1 = '';
					this.brand.v2 = '';
					this.errors.remove('brand_v1');
					return this.brand;
				}	
			},
			"engine_number.criteria": function(val){
				if(val== "all"){
					this.engine_number.v1 = '';
					this.engine_number.v2 = '';
					this.errors.remove('engine_number_v1');
				}
			},
			"frame_number.criteria": function(val){
				if(val == "all"){
					this.frame_number.v1 = '';
					this.frame_number.v2 = '';
					this.errors.remove('frame_number_v1');
					return this.frame_number;
				}	
			}
		},
		computed: {
			fas() {
				return fas;
			},
		},
		mounted () {
			this.APP_URL = process.env.VUE_APP_BACKEND_API_URL,
			$(".tblfind").find("select").on("change",function(){
				if($(this).val() == "all"){
					$(this).parents("tr").find("input").val("");
					$(this).parents("tr").find("input").prop("disabled",true);
					$(this).parents("tr").find(".vdp-datepicker").find("input[name='"+$(this).prop("name")+"_v1']").css("background-color", "#e9ecef");
					
					$(this).parents("tr").find(".nationality_v1 div.dropdown-toggle , .nationality_v1 input, .nationality_v1 button, .nationality_v1 i").css("background-color", "rgba(235, 238 ,220 ,0)");
					$(this).parents("tr").find(".nationality_v1").addClass("disabled");

					$(this).parents("tr").find("select.value").val("");
					$(this).parents("tr").find("select.value").prop("disabled",true);
				}else{
					$(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v1']").removeAttr("disabled");
					$(this).parents("tr").find("select[name='"+$(this).prop("name")+"_v1']").removeAttr("disabled");
					// For Datepicker
					$(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v1']").removeAttr("readonly");
					$(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v1']").removeAttr("disabled");
					$(this).find(".vdp-datepicker").find("input[name='"+$(this).prop("name")+"_v1']").css("background-color", "white");
					$(this).parents("tr").find(".vdp-datepicker").find("input[name='"+$(this).prop("name")+"_v1']").css("background-color", "white");
					
					if($(this).val() == "between"){
						$(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v2']").removeAttr("disabled");
						// For Datepicker
						$(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v2']").removeAttr("readonly");
						$(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v2']").removeAttr("disabled");
					}else{
						$(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v2']").val("");
						$(this).parents("tr").find("input[name='"+$(this).prop("name")+"_v2']").prop("disabled",true);
						// For Datepicker
						$(this).parents("table.tblfind").find("input[name='"+$(this).prop("name")+"_v2']").prop("disabled",true);

					}
				}
			});
			this.getCountries();
			this.searchVehicle(1, 'created_at', 'asc');
			$(".nationality_v1 div.dropdown-toggle, .nationality_v1 input, .nationality_v1 button, .nationality_v1 i").css("background-color", "rgba(235, 238 ,220 ,0)");
		},
		methods: {
			searchVehicle(pageNumber, order_by = null, order_type=null, searched = false) {
				this.forcepage = pageNumber;
				this.$validator.validate().then(result => {
					if (result){
						(order_by == null ? order_by = this.order_by : order_by);
						(order_type == null ? order_type = this.order_type_after_sort : order_type);
						this.$store.state.loading.status = true;
						let url = this.baseURI + 'backend/vehicle/search?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
						GDCE_Client.requestApi("POST", url, {
							plate_number: this.plate_number,
							nationality: this.nationality,
							brand: this.brand,
							engine_number: this.engine_number,
							frame_number: this.frame_number,
						}).then(response => {
							this.$store.state.loading.status = false;
							this.vehicles = response.data.data;
							this.last_page = response.data.last_page;
							(order_type == 'desc' ? this.order_type = 'asc' : this.order_type='desc');
							this.order_type_after_sort = order_type;
							this.order_by = order_by;
							this.permission.deleteVehicle = this.$hasPermission('tempvehicle.vehicle.delete');
						});
					}
					if(searched)
						this.$refs.paginate.selected = 1;
				});
			},
			getCountries() {
				this.$store.state.loading.status = true;
				let url = this.baseURI + 'reference/countries';
				GDCE_Client.requestApi("GET", url).then(response => {
					this.countries = response.data;
					this.$store.state.loading.status = false;
				});
			},		
			deleteVehicle(uuid){
				this.$swal({
					title: this.$t('label.confirm_delete'),
					icon: "warning",
					buttons: true,
					dangerMode: true
				}).then(willDelete => {	
					if (willDelete) {
						let url = this.baseURI + "/backend/vehicle/" + uuid;
						GDCE_Client.requestApi("DELETE", url).then(response => {
							this.searchVehicle(this.pageNumber, null, null);
						});
					}
				});
			}
		}
	}
</script>

<style scoped>
	.tblfind tr td {
		padding: 0px !important;
		border-top: 0px !important;
		line-height: 30px;
	}
	.tblfind tr th {
		line-height: 30px;
	}
	.form-control{
		border-radius: 0;
	}
	.form-group{
		margin-bottom: 0;
	}
	input, select{
		margin: 0;
	}
	.error_smg{
		color:red;
	}
	.disabled {
      	pointer-events:none;
      	color: #bfcbd9;
      	cursor: not-allowed;
      	background-image: none;
      	background-color: rgba(233, 236, 239, 1) !important;
      	border-color: #e9ecef;   
    }
</style>